module.exports = __webpack_public_path__ + "img/spxflow_logo_for_application2.f9d678b4.png";